import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Fab from "material-ui/FloatingActionButton";
import ContentAdd from "material-ui/svg-icons/content/add";
import Edit from "material-ui/svg-icons/image/edit";
import RaisedButton from "material-ui/RaisedButton";
import TextField from "material-ui/TextField";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";

import List from "../app/List";
import { getKindPrimaryText } from "../utils";
import {
  merchantList,
  merchantListSort,
  merchantListChangePage,
  merchantListSelect,
  merchantListFilter,
  merchantListToggleFiltering
} from "./actions";
import { checkPrivileges } from "../auth/privileges";
import auth from "../auth/constants";

class Filters extends Component {
  state = {
    q: "",
    kind: undefined
  };

  kindChanged = (e, i, value) => {
    this.setState({ kind: value });
  };

  searchChanged = (e, value) => {
    this.setState({ q: value });
  };

  submit = e => {
    e.preventDefault();
    const { q, kind } = this.state;
    this.props.submit(q, kind);
  };

  componentDidUpdate(prevProps) {
    if (this.props.opened && prevProps.opened !== this.props.opened) {
      this.refs.search.focus();
    }
  }

  render() {
    return (
      <form onSubmit={this.submit} className="list--filters">
        <TextField
          className="input-search"
          name="q"
          hintText="Que recherchez-vous ?"
          floatingLabelText="Votre recherche"
          value={this.state.q}
          onChange={this.searchChanged}
          ref="search"
        />
        {/* {TODO MERCHANT_GROUP MASQUER SELECTFIELD} */}
        <SelectField
          className="merchant-filter-kind"
          floatingLabelFixed
          floatingLabelText="Type"
          name="kind"
          autoWidth
          value={this.state.kind}
          onChange={this.kindChanged}
        >
          <MenuItem primaryText="Tous" />
          <MenuItem value="ASSU" primaryText={getKindPrimaryText("ASSU")} />
          <MenuItem value="ESF" primaryText={getKindPrimaryText("ESF")} />
          <MenuItem value="LIFT" primaryText={getKindPrimaryText("LIFT")} />
          <MenuItem value="HOT" primaryText={getKindPrimaryText("HOT")} />
          <MenuItem
            value="TOURIST_TAX"
            primaryText={getKindPrimaryText("TOURIST_TAX")}
          />
          <MenuItem value="STAND" primaryText={getKindPrimaryText("STAND")} />
          <MenuItem
            value="SKI_RENTAL"
            primaryText={getKindPrimaryText("SKI_RENTAL")}
          />
        </SelectField>
        <RaisedButton
          className="button"
          label="Recherche"
          type="submit"
          secondary
        />
      </form>
    );
  }
}

class MerchantList extends Component {
  componentDidMount() {
    this.props.loadList();
  }

  rowExtractor = code => this.props.list.byId[code];

  renderFab = (Icon, selectedId) => {
    const { user } = this.props;
    if (
      selectedId !== "new" ||
      checkPrivileges(user.privileges, auth.CREATE_MERCHANT)
    )
      return (
        <Link to={`/configuration/marchands/${selectedId}`}>
          <Fab className="fab" secondary>
            <Icon />
          </Fab>
        </Link>
      );
  };

  render() {
    const {
      list,
      select,
      filterList,
      sortList,
      changePage,
      toggleFiltering
    } = this.props;
    const Icon = list.selected ? Edit : ContentAdd;
    const selectedId = list.selected ? list.selected : "new";
    return (
      <div className="cards-container">
        <List
          title="Les marchands"
          model={[
            { label: "Code", target: "code" },
            { label: "Nom", target: "libelle" },
            { label: "Station", target: "resortLibelle" },
            { label: "SMoney AppAccountID", target: "sm_appaccountid" }
          ]}
          twoStepsSelectable={true}
          filters={<Filters opened={list.filtering} submit={filterList} />}
          toggleFiltering={toggleFiltering}
          changePage={changePage}
          exportUrl={list.exportUrl}
          select={select}
          sort={sortList}
          list={list}
          rows={list.all}
          rowExtractor={this.rowExtractor}
        />
        {this.renderFab(Icon, selectedId)}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.app.auth.user,
  list: state.merchant.list
});

const mapDispatchToProps = dispatch => ({
  loadList: () => {
    dispatch(merchantList());
  },
  sortList: column => {
    dispatch(merchantListSort(column));
    dispatch(merchantList());
  },
  changePage: page => {
    dispatch(merchantListChangePage(page));
    dispatch(merchantList());
  },
  filterList: (q, kind) => {
    dispatch(merchantListFilter(q, kind));
    dispatch(merchantList());
  },
  select: selected => {
    dispatch(merchantListSelect(selected));
  },
  toggleFiltering: () => {
    dispatch(merchantListToggleFiltering());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MerchantList);



// WEBPACK FOOTER //
// ./src/merchant/List.js